<template>
  <div class="report-header">
    <div class="row justify-content-center">
      <!-- <div class="col">
        <div class="d-flex" v-if="accountNo">
          <p style="margin-inline-end: 4px">{{ $t("reports.code") }}:</p>
          <p>{{ accountNo }}</p>
        </div>
        <h6 v-if="type != 'general'">
          {{ filterdPeriod != "" ? filterdPeriod : '' }}
        </h6>
        <div class="d-flex" v-if="accountName">
          <p style="margin-inline-end: 4px">{{ $t("reports.report_name") }}:</p>
          <p>{{ accountName }}</p>
        </div>
      </div> -->
      <div class="col text-center">
        <h5>
          {{ $i18n.locale == "ar" ? "هيئة المياه فرع " : "KSWC" }} -
          {{ $i18n.locale == "ar" ? branch_name : branch_name_en }}
        </h5>
        <h5>{{ reportName }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reportName", "filterdPeriod", "accountNo", "accountName", "type"],
  data() {
    return {
      branch_name: "",
      branch_name_en: "",
      headerAccountingPeriod: "During ",
    };
  },
  methods: {
    
  },
  created() {
    let current_user = JSON.parse(localStorage.currentUser);
    this.branch_name = current_user.branch_name;
    this.branch_name_en = current_user.branch_name_en;
  },
};
</script>
